import raw from './province-city-area';

// 调整省市的格式，便于使用
/**
 *
 * @param {object} raw 原始数据
 * @param {number} initialIndex
 * @param {number} limit 需要的层级数: 2 => 省市, 3 => 省市区
 */

const excluded = ['710000', '810000', '820000'];

export const formatter = (raw, initialIndex, limit) => {
  let parent = raw[initialIndex];
  let childIndexArray = Object.keys(parent);

  if (childIndexArray.length === 1) {
    parent = raw[childIndexArray[0]];
    childIndexArray = Object.keys(parent);
  }

  if (limit > 0) {
    return childIndexArray.map(childIndex => {
      const label = parent[childIndex];
      if (typeof raw[childIndex] === 'object') {
        return {
          label,
          value: label,
          children: formatter(raw, childIndex, limit - 1)
        };
      }
      return { label, value: label };
    });
  }
};

const countryIndex = 86;

excluded.forEach(index => {
  delete raw[countryIndex][index];
});

const districtMaker = (i = 2) => formatter(raw, countryIndex, i);

export default districtMaker;



// WEBPACK FOOTER //
// ./src/components/district-select/district/index.js